import { render, staticRenderFns } from "./media-clipboard-table.html?vue&type=template&id=45568741&scoped=true&"
import script from "./media-clipboard-table.js?vue&type=script&lang=js&"
export * from "./media-clipboard-table.js?vue&type=script&lang=js&"
import style0 from "./media-clipboard-table.scss?vue&type=style&index=0&id=45568741&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45568741",
  null
  
)

export default component.exports